import { render, staticRenderFns } from "./AddEdtGroupDlg.vue?vue&type=template&id=01c4b03c"
import script from "./AddEdtGroupDlg.vue?vue&type=script&lang=js"
export * from "./AddEdtGroupDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports